import Urls from "./Urls";

export default class Feedback {
  static async submitFeedback(message:string, author:string, lobbyKey?:string) {
    const resp = await fetch(Urls.SUBMIT_FEEDBACK, {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',

      },
      credentials: 'include',
      body: JSON.stringify({
        message,
        author,
        lobbyKey: lobbyKey || undefined,
      })
    }).catch((e) => ({ error: e }));
  }
}
